import React from 'react'
import {
  translate,
  List,
  Datagrid,
  TextField,
  EmailField,
  ReferenceManyField,
  Edit,
  DisabledInput,
  TextInput,
  SimpleForm,
  Create,
  SaveButton,
  EditButton,
  Toolbar,
  ViewTitle,
} from 'admin-on-rest'

const InstructorsTitle = ({ record }) => {
  return <span>Lector: {record ? `"${record.displayName}"` : ''}</span>
}

export const AdminInstructorEdit = props => (
  <Edit title={<InstructorsTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput label="Prenume" source="firstName" />
      <TextInput label="Nume" source="lastName" />
      <TextInput label="Titulatura" source="entitling" />
      <TextInput label="Nume afisat" source="displayName" />
      <TextInput label="Telefon" source="phoneNumber" />
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/admin/AdminInstructorEdit.js